import React from "react";
import { NavLink } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../services/firebase";
import { logUiEvent } from "../services/analytics";

const navItems = [
  { path: "/dashboard", label: "Create an App" },
  { path: "/apps", label: "View Apps" },
  { path: "/agents", label: "View Agents" },
  { path: "/build-agent-dev", label: "Build Agent (Dev)" },
  { path: "/build-webui-dev", label: "Build WebUI (Dev)" },
  { path: "/plan", label: "Plans & Billing" },
  { path: "/chat-dev", label: "Chat (Dev)" }
];

async function handleLogout() {
  try {
    await signOut(auth);
    logUiEvent("auth_logout");
  } catch (error) {
    logUiEvent("auth_logout_error", { message: error.message });
  }
}

function DrawerLayout({ user, children }) {
  const userDisplayName =
    user?.basicInfo?.displayName ||
    user?.email ||
    user?.basicInfo?.email ||
    "Signed in";

  const planLabel = user?.billingInfo?.plan
    ? `${user.billingInfo.plan} plan`
    : "Starter plan";

  return (
    <div className="layout">
      <aside className="drawer">
        <div className="brand">
          <img src="/logo192.png" alt="gofannon" />
          <div>
            <div className="brand__title">RamenAtA</div>
            <div className="brand__subtitle">Your Killer App is Waiting...</div>
          </div>
        </div>
        <div className="drawer__content">
          <nav className="drawer__nav">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  isActive ? "drawer__link drawer__link--active" : "drawer__link"
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="drawer__account">
            <div className="drawer__accountMeta">
              <div className="drawer__user">{userDisplayName}</div>
              <div className="drawer__plan">{planLabel} · metered LLM usage</div>
            </div>
            <div className="drawer__actions">
              <NavLink
                to="/profile"
                className={({ isActive }) =>
                  isActive
                    ? "button secondary full-width drawer__profile drawer__profile--active"
                    : "button secondary full-width drawer__profile"
                }
              >
                Profile & usage
              </NavLink>
              <button className="button danger full-width" type="button" onClick={handleLogout}>
                Log out
              </button>
            </div>
          </div>
        </div>

        <div className="drawer__footer">
          <p className="muted">All changes auto-synced to Firestore.</p>
          <p className="muted">Analytics enabled for all front-end events.</p>
        </div>
      </aside>
      <main className="main-content">{children}</main>
    </div>
  );
}

export default DrawerLayout;
